<app-data-table
  [data]="dataSource"
  [columns]="columns"
  [actions]="actions"
  [displayedColumns]="displayedColumns"
></app-data-table>
